module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.7.0-129.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.7.0.md
// module id = 546
// module chunks = 253